<div class="card" style="max-height: 300px;max-width:600px ;min-height: 300px;min-width:600px ;">
 
    <div class="card-body">
      <div class="row" style="text-align: center;">
        <div class="col-sm-12">
          <img src="../../../../assets/images/internet dino.png"
          alt="Landy Logo" height="150"  >
        </div>
      </div>
      <br>
      <div class="row" style="text-align: center;">
        <div class="col-sm-12">
          <h5>Unable to connect to the Internet!</h5>
        </div>
      </div>
      <br>
    
      <p class="text-center">
        <button nbButton  (click)="onLogIn()"
          size="tiny" status="primary" type="submit" >
         OK
        </button>
      
      </p>
    </div>  
    </div>
    
    